<template>
  <div class="hyActivityDetail">
    <navtab class="navTab"></navtab>
    <div class="cont">
      <!-- <el-row class="tac">
            <el-col :span="12">
              <el-menu
                default-active="2"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
                background-color="#fdfdfd"
                text-color="#000000"
                active-text-color="#0505b1">
                <el-menu-item v-for="(val,index) in typeList" :key="index" index="index" @click="getHy(val.id)">
                  <i class="el-icon-menu"></i>
                  <span slot="title">{{val.name}}</span>
                </el-menu-item>
              </el-menu>
            </el-col>
      </el-row>-->
      <div class="backBtn el-icon-arrow-left" @click="toLastPage()">返 回</div>
      <!-- <div class="lef">
            <div class="backBtn" @click="toLastPage()">返     回</div>
            <p class="modelPart">最新动态</p>
            <ul class="detailList">
                <li @click="getnewsDetail(val.id)" v-for="(val,index) in splitNewsList" :key="index">·   {{val.name}}</li>
            </ul>
            <el-pagination
                background
                :pager-count="7"
                :page-size=showNum
                layout="prev, pager, next"
                :total=total
                class="fenye"
                :current-page="currentPage"
                @current-change="getNewsPageList">
            </el-pagination>
      </div>-->
      <div class="rig">
        <img
          src="../assets/saveShow.png"
          alt
          id="saveImg"
          v-show="!signFlag"
          @click="save(newsDetail.id)"
        />
        <!-- collectType //0为收藏 1 为没有收藏 -->
        <img
          src="../assets/saveHidden.png"
          alt
          id="saveImg"
          v-show="signFlag"
          @click="save(newsDetail.id)"
        />
        <!-- collectType //0为收藏 1 为没有收藏 -->
        <p class="titlePar">
          <span class="title">{{newsDetail.name}}</span>
        </p>
        <p class="time">{{newsDetail.createtime}}</p>
        <div class="contDetail" v-html="newsDetail.content" ref="newsDetail"></div>
      </div>
    </div>
    <!-- <div class="address" v-html="htmlWord"></div> -->
  </div>
</template>

<script>
import $ from "jquery";
import navtab from "./navtab";
export default {
  name: "index",
  components: {
    navtab: navtab
  },
  data() {
    return {
      // htmlWord:
      // "Copyright&nbsp©&nbsp2016-2019&nbsp浙江桃园科技有限公司&nbsp&nbsp|&nbsp&nbsp 技术支持：杭州互办网络科技有限公司",
      typeList: [],
      newsList: [],
      splitNewsList: [],
      total: 100,
      currentPage: 1,
      showNum: 10,
      typeid: 1,
      user: "",
      newsDetail: "",
      industryid: "",
      detailId: "",
      showFlag: 0,
      signFlag: true,
      userName: ""
    };
  },

  methods: {
    // /api/Yddatabase/Collection/{dataId}/{userName}/{type}收藏资料增加
    save(id) {
      //console.log(id);
      // //console.log(this.signFlag);
      // //console.log(!this.signFlag);
      if (JSON.parse(sessionStorage.getItem("user"))) {
        this.$axios
          .get(
            this.$http +
              "api/Yddatabase/Collection/" +
              this.detailId +
              "/" +
              this.user.userName +
              "/" +
              2
          )
          .then(res => {
            //console.log(res);
            if (res.data.code == 0) {
              this.signFlag = !this.signFlag;
              //console.log(this.signFlag);
              // alert(res.data.msg);
              this.$notify({
                title: "成功",
                message: res.data.msg,
                type: "success"
              });
              //console.log(res.data);
            } else if (res.data.code == 500) {
              this.signFlag = !this.signFlag;
              //console.log(this.signFlag);
              this.$notify({
                title: "成功",
                message: res.data.msg,
                type: "success"
              });
            } else {
              // alert(res.data.msg);
              this.$notify({
                title: "消息",
                message: res.data.msg,
                type: "warning"
              });
            }
          })
          .catch(err => {});
      } else {
        this.$notify({
          title: "温馨提示",
          message: "请先登录才能添加收藏哦！",
          type: "warning"
        });
      }
    },
    toLastPage() {
      this.$router.go(-1);
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    //  获取行业动态分类列表 /api/Home/Industry 行业分类
    // getType() {
    //   //console.log("111");
    //   this.$axios({
    //     method: "get",
    //     url: this.$http + "api/Home/Industry"
    //   })
    //     .then(res => {
    //       if (res.data.code == 0) {
    //         //console.log(res.data);
    //         this.getHy(res.data.Entity[0].id);
    //         this.typeList = res.data.Entity;
    //       }
    //     })
    //     .catch(error => {
    //       //console.log(error);
    //     });
    // },
    // 获取具体的行业新闻  /api/Home/SelectDynamic/{IndustryId}通过行业分类ID查询行业
    getHy(typeid) {
      //console.log("222");
      //console.log(typeid);
      this.$axios
        .get(this.$http + "api/Home/SelectDynamic/" + typeid)
        .then(res => {
          if (res.data.code == 0) {
            //console.log("获取成功");
            //console.log(res.data);
            this.newsList = res.data.Entity;
            this.total = this.newsList.length;
            //console.log(this.total);
            this.getNewsPageList(1);
            // this.getnewsDetail(this.newsList[0].id);
          } else {
            //console.log("获取失败");
          }
        })
        .catch(err => {});
    },
    // 对新闻进行分页处理
    getNewsPageList(currentPage) {
      //console.log("333");
      //console.log(this.newsList);
      //console.log(currentPage);
      this.currentPage = currentPage;
      let start = this.showNum * (currentPage - 1);
      let end = this.showNum * currentPage;
      //console.log(start, end);
      this.splitNewsList = this.newsList.slice(start, end);
      //console.log(this.splitNewsList);
    },
    // 获取新闻详情 /api/Home/SelectDynamicByID/{dynamicId}/{userName}通过行业ID查询详情
    getnewsDetail(dynamicId) {
      //console.log(this.user);
      this.$axios
        .get(
          this.$http +
            "api/Home/SelectDynamicByID/" +
            dynamicId +
            "/" +
            this.userName
          // this.user.userName
        )
        .then(res => {
          if (res.data.code == 0) {
            //console.log("获取新闻详情 成功");
            //console.log(res.data);
            this.newsDetail = res.data.Entity;
            if (this.newsDetail.collectType == 0) {
              // this.showFlag = 0;
              this.signFlag = true;
              //console.log(this.signFlag);
            } else {
              // this.showFlag = 1;
              this.signFlag = false;
              //console.log(this.signFlag);
            }
            //console.log(this.newsDetail);
            collectType; //0为收藏 1 为没有收藏
            this.exampleSolve(this.$refs.newsDetail);
          } else {
            //console.log("获取新闻详情 失败");
          }
        })
        .catch(err => {});
    },
    // 获取目标元素，返回数组
    exampleSolve(domele) {
      let refEle = domele;
      //console.log(domele);
      this.$nextTick(() => {
        let imgArr = refEle.getElementsByTagName("img");
        //console.log(imgArr);
        this.handleStyle(imgArr);
        let videoArr = refEle.getElementsByTagName("video");
        this.handleStyle(videoArr);
        //console.log(videoArr);
      });
    },
    // 处理富文本中的img 和 video标签元素
    handleStyle(ele) {
      let elem = ele;
      let maxWidth = $(".contDetail").width();
      let ratio = 0;
      for (let i = 0; i < elem.length; i++) {
        //console.log($(elem[i]).width(), maxWidth);
        if ($(elem[i]).width() > maxWidth) {
          //console.log(elem[i]);
          ratio = $(elem[i]).width() / maxWidth;
          var height = $(elem[i]).height() / ratio;
          //console.log($(elem[i]).height(), ratio);
          $(elem[i]).css({
            width: maxWidth + "px",
            height: height + "px",
            margin: "0 auto",
            display: "block"
          });
          //console.log($(elem[i]).width());
        } else if ($(elem[i]).width() < maxWidth) {
          ratio = $(elem[i]).width() / maxWidth;
          var height = $(elem[i]).height() / ratio;
          $(elem[i]).css({
            width: maxWidth + "px",
            height: height + "px",
            margin: "0 auto",
            display: "block"
          });
        }
      }
    }
  },

  created() {},
  mounted() {
    if(sessionStorage.getItem("user")){
      this.user = JSON.parse(sessionStorage.getItem("user"));
    }
    if (sessionStorage.getItem("user")) {
      this.userName = this.user.userName;
    } else {
      this.userName = undefined;
    }
    this.industryid = this.$route.params.industryid;
    this.detailId = this.$route.params.detailId;
    //console.log(this.industryid, this.detailId);
    this.getHy(this.industryid);
    this.getnewsDetail(this.detailId);

    // this.getType();
  }
};
</script>

<style>
#saveImg {
  position: absolute;
  display: block;
  height: 22px;
  width: 22px;
  right: 10px;
  top: 3px;
  cursor: pointer;
}
.el-row {
  /* width: 10%; */
  height: 100%;
  /* background-color: pink; */
}
.el-col-12 {
  width: 100%;
}
.el-row ul {
  width: 100%;
}
.el-row li {
  width: 100%;
}
.hyActivityDetail {
  min-height: 100vh;
  background-color: #fafafa;
}
.hyActivityDetail .navTab {
  box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
  z-index:999;
}
.hyActivityDetail .cont {
  width: 80%;
  margin: 0 auto;
  background-color: #fff;
  margin-top: 20px;
  padding: 10px 0;
}
.hyActivityDetail .cont .lef {
  width: 24%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 5px;
  border: 1px solid #f7f7f7;
}
.hyActivityDetail .cont .rig {
  width: 98%;
  position: relative;
  margin-left: 20px;
  margin-top: 33px;
}
.hyActivityDetail .backBtn {
  border-radius: 2px;
  /* font-weight: 600; */
  font-size: 14px;
  width: 100%;
  /* height: 50px; */
  line-height: 33px;
  text-align: left;
  color: #4c4b4b;
  /* background-color: #158DD3; */
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  text-indent: 1em;
}
.hyActivityDetail .cont .lef .modelPart {
  font-weight: 600;
  font-size: 15px;
  text-align: left;
  margin: 20px 0;
}
.hyActivityDetail .cont .lef .detailList {
  width: 100%;
  margin-bottom: 4%;
  padding-left: 6px;
}
.hyActivityDetail .cont .lef .detailList li {
  text-align: left;
  font-size: 14px;
  line-height: 26px;
  color: #7d7979;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
  /* border-bottom: 1px solid #158DD3; */
}
.hyActivityDetail .cont .lef .detailList li:hover {
  color: #158DD3;
}
.hyActivityDetail .cont .rig .titlePar {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.hyActivityDetail .cont .rig .titlePar .title {
  font-size: 24px;
  /* font-weight: 600; */
  text-align: left;
}
.hyActivityDetail .cont .rig .time {
  width: 100%;
  font-size: 14px;
  color: #7d7979;
  text-align: left;
  margin-top: 20px;
}
.hyActivityDetail .cont .rig .contDetail {
  margin-top: 3%;
  font-size: 14px;
  color: #7d7979;
  line-height: 36px;
  text-align: justify;
  text-align-last: left;
  -moz-text-align-last: left;
  text-indent: 2em;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #158DD3;
  color: #fff;
}
.el-pagination.is-background .el-pager li {
  cursor: pointer;
}
/* .hyActivityDetail .address {
    width: 80%;
    margin: 0px auto;
    margin-bottom: 0;
    font-size: 12px;
    color: gray;
    padding-bottom: 32px;
    background-color: #fff;
    padding: 32px 0;
} */
</style>



// WEBPACK FOOTER //
// src/components/hyActivityDetail.vue